"use client";

import { useEffect } from "react";

import type { TocExtendDetail } from "@/components/general/general-page-toc";

export function CookieDeclarationTocSync({
  anchorId,
  items,
  groupId = "cookie-declaration",
}: {
  anchorId: string;
  items: TocExtendDetail["items"];
  groupId?: string;
}) {
  useEffect(() => {
    if (items.length === 0) return;
    window.dispatchEvent(
      new CustomEvent<TocExtendDetail>("tf:toc-extend", {
        detail: { groupId, anchorId, items },
      }),
    );
  }, [anchorId, groupId, items]);

  return null;
}
